import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { useFormattedMessageAndIcon } from '../../utils/use-formatted-message-and-icon/index.tsx';
import messages from './messages.tsx';

export const useMoreFormattedMessageAndIcon = () =>
	useFormattedMessageAndIcon(messages.more, ShowMoreHorizontalIcon);
